import { useState, useEffect } from 'react';

export default function useWindowWidth() {

  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {

    const handleResize = () => {
      setWidth(window.innerWidth);
      setIsMobile(window.innerWidth <= 600);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}